import { themeColor } from 'LibNeo'
import styled, { css } from 'styled-components'

export const WrapperHistory = styled.div`
	display: flex;
	gap: 10px;
	padding-left: 4px;
`

export const Line = styled.div<{ lastEvent?: boolean }>`
	position: relative;
	padding-top: 6px;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 1px;
		height: 6px;
		background-color: ${themeColor('gray', 3)};
	}
	${({ lastEvent }) =>
		!lastEvent &&
		css`
			&::after {
				content: '';
				position: absolute;
				top: 14px;
				left: 50%;
				transform: translateX(-50%);
				width: 1px;
				height: calc(100% - 14px);
				background-color: ${themeColor('gray', 3)};
			}
		`}
`

export const Circle = styled.div`
	min-width: 8px;
	height: 8px;
	border: 1px solid ${themeColor('gray', 4)};
	border-radius: 50%;
	position: relative;
	z-index: 1;
`

export const HistoryContent = styled.div`
	padding-bottom: 20px;
	display: flex;
	flex-direction: column;
	gap: 2px;
`
